import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=2933a0cc&scoped=true"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=2933a0cc&prod&scoped=true&lang=css"
import style1 from "./EditProfile.vue?vue&type=style&index=1&id=2933a0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2933a0cc",
  null
  
)

export default component.exports